<template>
  <div>
    <div class="hm-stage-box">
      <!--    图片轮播   -->
      <div class="hm-stage-box-img" v-if="this.value.radio == 0">
        <SpImage :src="this.value.img" class="pic" />
      </div>
      <!--    视频  -->
      <div class="hm-stage-box-video" v-if="this.value.radio == 1">
        <video-player
          :options="{
          aspectRatio: aspectRatio,
          sources: [
            {
              type: 'video/mp4',
              src: sourceUrl
            }
          ],
          notSupportedMessage: '添加视频源',
          suppressNotSupportedError: true,
          controlBar: false
        }"
        />
      </div>
      <!--    按钮   -->
      <div class="hm-stage-btn">
        {{value.cta.desc}}
      </div>
      <div class="hm-stage-title" :style="{color: value.titleData.color}">
        {{value.titleData.title}}
      </div>
    </div>
  </div>
</template>
<script>
import config from './config'
import { proportions } from './config'
export default {
  name: "HmStage",
  wgtName: 'HmStage',
  wgtDesc: 'stage',
  wgtIcon: 'wgt-search',
  config: config,
  props: {
    value: [Object, Array]
  },
  computed: {
    aspectRatio() {
      const { proportion } = this.value
      return proportions.find((item) => item.label == proportion).name
    },
    sourceUrl (){
      const {video } = this.value
      return video || ''
    }
  }
}
</script>
<style lang="scss">
.hm-stage-box{
  position: relative;
  height: auto;
  .hm-stage-box-img{
    height: 700px;
    .pic{
      height: 100%;
    }
  }
  .video-player {
    .vjs-big-play-button {
      display: none;
    }
    .vjs-error-display {
      &::before {
        display: none;
      }
    }
    .vjs-modal-dialog-content {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .hm-stage-btn{
    position: absolute;
    bottom: 19px;
    left: 50%;
    min-width: 57px;
    min-height: 24px;
    padding: 0 8px;
    background: white;
    transform: translateX(-50%);
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0.28px;
    text-transform: uppercase;
    color: #000;
  }
  .hm-stage-title{
    position: absolute;
    bottom: 58px;
    font-size: 38px;
    left: 50%;
    transform: translateX(-50%);
    color: white;
    font-weight: 900;
  }
}
</style>
